import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";

function Adminslider() {
  const [data, setdata] = useState([]);
  const apiURL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getusers();
  }, []);

  const getusers = () => {
    try {
      axios
        .get(`/api/admin/getallslider`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setdata(response.data.slider);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };

  const postdeleteimage = async (data) => {
    try {
      const config = {
        url: "/admin/deleteslider/" + data._id,
        method: "post",
        baseURL: "/api",
        headers: { "content-type": "multipart/form-data" },

        //responseType:"application/json"
      };
      let res = await axios(config);
      if (res.status === 200) {
        console.log(res.data);
        alert("slider deleted successfully");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ background: "#fff" }}>
      <h2 style={{ color: "#01a695", textAlign: "center" }}> slider </h2>
      <Table responsive hover size="md" style={{ margin: "30px" }}>
        <thead>
          <tr>
            <th>S. no</th>
            <th>Image</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((datas) => (
            <tr>
              <td>1</td>
              <td>
                {" "}
                <img
                  src={"/uploads/" + datas.slider}
                  height="100px"
                  width="100px"
                  style={{ borderRadius: "100%" }}
                />{" "}
              </td>

              <td>
                {" "}
                <button
                  className="btn btn-outline-danger"
                  onClick={() => postdeleteimage(datas)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {/* <tr>
                                    <td>DR David</td>
                                    <td><img src="" height /></td>                                                               
                                    <td><div className=""> <button className="btn btn-danger">Cancel</button> </div></td>
                                </tr> */}
        </tbody>
      </Table>
    </div>
  );
}

export default Adminslider;
